import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { PullToRefresh, ListView, ActivityIndicator, Toast } from 'antd-mobile'
import {
  addGood as addGoodApi,
  delGood as delGoodApi,
  fetchGoodsCount as fetchGoodsCountApi,
} from '@/api/store'
import { GOODS_SET_COUNT } from '@/action-types/goods'
import Good from '@/components/good'
import { goodStorage } from '@/util/good-storage'
import './goods.less'
const APullToRefresh: any = PullToRefresh

const Footer = ({ isLoading, isHasMore, noHasMore }: any) => {
  if (!isHasMore) {
    return noHasMore || <div className="text-center">没有更多啦</div>
  }
  return (
    <div className="flex-lvc">
      {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
    </div>
  )
}

interface Props {
  id?: string
  depot_id: string
  key?: string
  addCart?: (dom: HTMLElement) => void
  api: (params: any) => any
  notbuyable?: boolean
  setGoodsCountAction: (count: string | number) => any
}
const mapStateToProps = (state: any) => {
  return {
    depot_id: state.depot.id,
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  setGoodsCountAction: (count: string | number) =>
    dispatch({ type: GOODS_SET_COUNT, count }),
})

@(connect(
  mapStateToProps,
  mapDispatchToProps,
) as any)
export class Goods extends Component<Props & any, any> {
  // TODO: 废弃未删除静态代码
  private static registered: any[] = []
  private static register(callback: any) {
    if (typeof callback === 'function') {
      this.registered.push(callback)
    }
  }
  private static _dataBlobs: any = (() => {
    const map = new Map()
    const _set = map.set
    map.set = (key: any, value: any) => {
      let bool
      if (map.has(key)) {
        bool = true
      }
      const tempMap = _set.apply(map, [key, value])
      bool && goodStorage.registered.forEach((cb: any) => cb(key))
      return tempMap
    }
    return map
  })()
  public static set dataBlobs(map: any) {
    this._dataBlobs = map
  }
  public static get dataBlobs() {
    return this._dataBlobs
  }



  el!: ListView
  sectionIDs = ['0']
  rowIDs: any = [[]]
  dataBlobs: any = {}
  page = 1
  isHasMore = true

  private touchPos: any = {
    startX: 0,
    startY: 0,
    moveEndX: undefined,
    moveEndY: undefined,
    X: 0,
    Y: 0,
    direction: 0,
    lrLock: false,
    tbLock: false,
  }

  constructor(props: any) {
    super(props)
    const getRowData = (dataBlob: any, _: any, rowID: any) =>
      dataBlob.get(rowID)
    const dataSource = new ListView.DataSource({
      getRowData,
      rowHasChanged: (row1: any, row2: any) => true,
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
    })
    this.state = {
      dataSource,
      isLoading: true,
      height: (document.documentElement.clientHeight * 3) / 4,
      isRefreshing: false,
    }
    goodStorage.register((key: string) => {
      const index = this.rowIDs[0].indexOf(key)
      if (~index) {
        // this.state.dataSource.rowShouldUpdate(0, index)
        this.setState({ dataSource: this.state.dataSource })
      }
    })
  }

  onRefresh = async () => {
    // 是否左右滑动
    if (this.touchPos.lrLock) {
      return
    }
    // 是否在加载中
    if (this.state.isLoading) {
      return
    }
    this.page = 1
    this.rowIDs = [[]]
    this.setState({ isRefreshing: true, isLoading: true })
    await this.getGoods()
    this.setState({
      isRefreshing: false,
    })
  }

  onEndReached = async () => {
    if ((this.state as any).isLoading && !(this.state as any).hasMore) {
      return
    }
    this.setState({ isLoading: true })
    this.page++
    await this.getGoods()
  }

  getGoods = async () => {
    const { depot_id, api } = this.props
    if (!depot_id) {
      return
    }
    const { page } = this
    const good = await api({ page })
    if (good.length <= 0) {
      this.isHasMore = false
      this.setState({ isLoading: false })
    }

    for (let i = 0; i < good.length; i++) {
      let { goods_id } = good[i]
      // good[i].buy_count = parseInt(good[i].buy_count)
      this.rowIDs[0].push(goods_id)
      if (
        !goodStorage.dataBlobs.has(goods_id) ||
        JSON.stringify(goodStorage.dataBlobs.get(goods_id)) !==
        JSON.stringify(good[i])
      ) {
        goodStorage.dataBlobs.set(goods_id, good[i])
      }
    }
    this.setState({
      dataSource: this.state.dataSource.cloneWithRowsAndSections(
        goodStorage.dataBlobs,
        this.sectionIDs,
        this.rowIDs,
      ),
      isLoading: false,
    })
  }

  async componentDidMount() {
    const element = ReactDOM.findDOMNode(this.el) as Element
    const height =
      document.documentElement.clientHeight -
      element.getBoundingClientRect().top

    window.addEventListener('resize', this.setHeight)
    await this.getGoods()
    this.setState({
      dataSource: this.state.dataSource.cloneWithRowsAndSections(
        goodStorage.dataBlobs,
        this.sectionIDs,
        this.rowIDs,
      ),
      isLoading: false,
      height,
    })
    element.addEventListener(
      'touchstart',
      (e: any) => {
        this.touchPos.startX = e.touches[0].pageX

        this.touchPos.startY = e.touches[0].pageY
      },
      false,
    )
    element.addEventListener('touchmove', (e: any) => {

      if (this.touchPos.lrLock || this.touchPos.tbLock) {
        return
      }

      this.touchPos.moveEndX = e.changedTouches[0].pageX

      this.touchPos.moveEndY = e.changedTouches[0].pageY

      this.touchPos.X = this.touchPos.moveEndX - this.touchPos.startX

      this.touchPos.Y = this.touchPos.moveEndY - this.touchPos.startY

      const { X, Y } = this.touchPos



      if (Math.abs(X) > Math.abs(Y) && X > 0) {
        // alert("向右");
        this.touchPos.lrLock = true
      } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
        // alert("向左");
        this.touchPos.lrLock = true
      } else if (Math.abs(Y) > Math.abs(X) && Y > 0) {
        this.touchPos.tbLock = true
        // alert("向下");
      } else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
        this.touchPos.tbLock = true
        // alert("向上");
      }
    })
    element.addEventListener('touchmove', (e: any) => {
      // if (this.touchPos.lrLock) {
      //   // this.setState({refreshing: false})
      //   e.preventDefault()
      // }
      if (this.touchPos.tbLock) {
        e.stopPropagation()
      }
    })
    element.addEventListener('touchend', e => {
      if (this.touchPos.lrLock) {
        (element.querySelector('.am-pull-to-refresh-content-wrapper') as any).classList.remove('none');
        (element.querySelector('.am-pull-to-refresh-content') as any).style = undefined
      }
      this.touchPos.lrLock = false
      this.touchPos.tbLock = false;

    });

    (element.querySelector('.am-pull-to-refresh-content-wrapper') as any).addEventListener('touchmove', (e: any) => {
      if (this.touchPos.lrLock) {
        (element.querySelector('.am-pull-to-refresh-content-wrapper') as any).classList.add('none')
      }
    })

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setHeight)
  }

  setHeight = () => {
    try {
      const height =
        document.documentElement.clientHeight -
        (ReactDOM.findDOMNode(this.el) as any).getBoundingClientRect().top
      this.setState({ height })
    } catch (e) { }
  }

  increaseGood = async (event: any, goods_id: any) => {
    // window.WebViewBridge?.shouldShowTabBar(false)
    if (window.WebViewBridge?.eventLabel) {
      window.WebViewBridge?.eventLabel('click_Store_addcart', '')
    } else if (window.webkit) {
      window.webkit.messageHandlers.eventLabel.postMessage({'id': 'click_Store_addcart'})
    } 
    const { target } = event

    const { depot_id, addCart } = this.props

    const { data } = await addGoodApi({ depot_id, id: goods_id })

    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2)
      return
    }

    goodStorage.increment(goods_id)
    addCart &&
      addCart(
        target.closest('.good').querySelector(
          '.good-cover',
        )
      )
  }
  decreaseGood = async (goods_id: string) => {
    const { depot_id, notbuyable } = this.props
    const { data } = await delGoodApi({ depot_id, id: goods_id })

    if (data.code !== 'SUCCESS') {
      return
    }

    goodStorage.decrement(goods_id)

    if (notbuyable && goodStorage.dataBlobs[goods_id].buy_count === 0) {
      const rowIDs = [...this.rowIDs[0]]
      rowIDs.splice(this.rowIDs[0].indexOf(goods_id), 1)
      this.rowIDs[0] = [...rowIDs]
    }
  }

  // 使用前端计数
  getGoodsCount = () => {
    const { depot_id, setGoodsCountAction } = this.props
    fetchGoodsCountApi(depot_id).then(({ data }) => {

      setGoodsCountAction(data.data)
    })

  }

  render() {
    const { isRefreshing, isLoading } = this.state
    const { isHasMore } = this
    const separator = (sectionID: any, rowID: any) => (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 1,
          borderTop: '0.5px solid #ECECED',
          borderBottom: '0.5px solid #ECECED',
        }}
      />
    )
    return (
      <ListView
        className="goods-wrap"
        ref={el => (this.el = el as ListView)}
        dataSource={this.state.dataSource}
        initialListSize={100}
        renderRow={good => (
          <Good
            good={good}
            decrease={this.decreaseGood}
            increase={this.increaseGood}
          />
        )}
        renderSeparator={separator}
        renderFooter={() => (
          <Footer isLoading={isLoading} isHasMore={isHasMore} />
        )}
        style={{
          height: this.state.height,
          overflow: 'auto',
        }}
        pullToRefresh={
          <APullToRefresh
            refreshing={isRefreshing}
            onRefresh={this.onRefresh}
          // distanceToRefresh={50}
          />
        }
        onEndReached={this.onEndReached}
      />
    )
  }
}
